const projectProgress = require('./config/progress.json')

export default projectProgress
